import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ChatbotRTKService } from "../app/services/chatbot-rtk.services";
import { RootState } from "../app/store";
import IBotVersions from "../interfaces/models/Knowledge/bot-version.interface";
import ICreateKnowledge from "../interfaces/models/Knowledge/create-knowledge.interface";
import ICreateKnowledgeQuestion from "../interfaces/models/Knowledge/create-knowledge-question.interface";
import ICreateKnowledgeStep from "../interfaces/models/Knowledge/create-knowledge-step.interface";
import IKnowledgeState from "../interfaces/models/Knowledge/knowledge-state.interface";
import IUpdateKnowledgeAssistant from "../interfaces/models/Knowledge/update-knowledge-assistant.interface";
import IXlSFile from "../interfaces/models/Knowledge/xlS-file.interface";
import IAssistant from "../interfaces/response/assistant.interface";
import { BotTypeEnum } from "../utils/BotTypeEnum";

const initialState: IKnowledgeState = {
  create: {
    botType: "Widget",
    isSideMenu: true,
    isEdit: false,
    currentStep: "main",
    stepNumber: 1,
    step: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-02"
      },
      // {
      //   name: "choose-model",
      //   description: "IKnowledgeState/des-03",
      //   stepDescription: "IKnowledgeState/des-04"
      // },
      {
        name: "upload-data",
        description: "IKnowledgeState/des-03",
        stepDescription: "IKnowledgeState/des-05"
      },
      {
        name: "select-columns",
        description: "IKnowledgeState/des-03",
        stepDescription: "IKnowledgeState/des-06"
      }
    ],
    scenarioSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-02"
      },
      // For new page of text scenario
      {
        name: "mainStarterKit",
        description: "Select starter",
        stepDescription: "IKnowledgeState/des-20"
      },
      // End =====
      {
        name: "conditional-scenario",
        stepDescription: "IKnowledgeState/des-07"
      }
    ],
    VideoScenarioSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-14",
        stepDescription: "IKnowledgeState/des-02"
      },
      {
        name: "video-scenario",
        stepDescription: "IKnowledgeState/des-15"
      }
    ],
    finetuneSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-02"
      },
      // {
      //   name: "choose-model",
      //   description: "IKnowledgeState/des-03",
      //   stepDescription: "IKnowledgeState/des-04"
      // },
      {
        name: "upload-data",
        description: "IKnowledgeState/des-03",
        stepDescription: "IKnowledgeState/des-05"
      },
      {
        name: "select-columns",
        description: "IKnowledgeState/des-03",
        stepDescription: "IKnowledgeState/des-06"
      }
    ],
    assistantBotSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-02"
      },
      {
        name: "assistant-speed",
        description: "IKnowledgeState/des-03",
        stepDescription: "AssistantSpeedPage/title-widget"
      },
      {
        name: "assistant-choose-type",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-09"
      },
      {
        name: "assistant-bot",
        title: "IKnowledgeState/t-01",
        description: "IKnowledgeState/des-10",
        stepDescription: "IKnowledgeState/des-11"
      }
    ],
    kbAssistantBotSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-02"
      },
      {
        name: "assistant-speed",
        description: "IKnowledgeState/des-03",
        stepDescription: "AssistantSpeedPage/title-widget"
      },
      {
        name: "kb-assistant-choose-type",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-09"
      },
      {
        name: "kb-assistant-bot",
        title: "IKnowledgeState/t-01",
        description: "IKnowledgeState/des-10",
        stepDescription: "IKnowledgeState/des-11"
      },
      {
        name: "kb-assistant-upload-file",
        title: "IKnowledgeState/t-01",
        description: "IKnowledgeState/des-10",
        stepDescription: "IKnowledgeState/des-16"
      }
    ],
    ppAssistantBotSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-17",
        stepDescription: "IKnowledgeState/des-02"
      },
      {
        name: "assistant-speed",
        description: "IKnowledgeState/des-03",
        stepDescription: "AssistantSpeedPage/title-widget"
      },
      {
        name: "pp-assistant-insert-domain",
        description: "IKnowledgeState/des-17",
        stepDescription: "IKnowledgeState/des-18"
      },
      {
        name: "pp-assistant-auto-update",
        title: "IKnowledgeState/t-17",
        description: "IKnowledgeState/des-17",
        stepDescription: "IKnowledgeState/des-19"
      }
    ],
    assistantCloneBotSteps: [
      {
        name: "main",
        description: "IKnowledgeState/des-01",
        stepDescription: "IKnowledgeState/des-13"
      },
      {
        name: "assistant-speed",
        description: "IKnowledgeState/des-03",
        stepDescription: "AssistantSpeedPage/title"
      },
      {
        name: "assistant-clone",
        title: "IKnowledgeState/t-01",
        description: "IKnowledgeState/des-10",
        stepDescription: "IKnowledgeState/des-11"
      }
    ],
    isNextStep: true,
    isPreviousStep: false,
    fileXls: null,
    fileXlsValue: [],
    fileXlsName: "",
    chatbotTitle: "",
    chatbotPrevTitle: "",
    chatbotService: "",
    chatbotModel: "",
    openAiAPIKey: "",
    inputs: [],
    outputs: [],
    questions: [],
    assistant: null,
    assistantWelcomeMessage: "",
    assistantCompanyName: "",
    assistantAgentName: "",
    additional_instruction: "",
    assistantInstructions: {},
    files: [],
    domainAddress: "",
    ppAutoUpdate: "never",
    selectServiceFromOutside: false,
    scenarioTemplateId: null,
    SpeedModel: "FAST_SMART"
  },
  apiKey: null,
  defaultScenario: null,
  expiredDate: null,
  maxUsageKitty: null,
  usageKitty: null,
  maxToken: 1000,
  model: null,
  botVersions: [],
  currentPackageName: null
};

export const KnowledgeSlice: any = createSlice({
  name: "KnowledgeSlice",
  initialState,
  reducers: {
    setChatbotTitle: (state, action: PayloadAction<string>) => {
      state.create.chatbotPrevTitle = state.create.chatbotTitle;
      state.create.chatbotTitle = action.payload;
    },
    setChatBotService: (
      state,
      action: PayloadAction<
        | BotTypeEnum.AI_READY_TO_USE
        | BotTypeEnum.AI_WITH_KNOWLEDGE_BASE
        | BotTypeEnum.SITE_SCAN_PLUG_AND_PLAY
        | BotTypeEnum.TEXT_SCENARIO
        | BotTypeEnum.HUMAN_CLONE
        | BotTypeEnum.VIDEO_SCENARIO
      >
    ) => {
      state.create.chatbotService = action.payload;
      state.create.isSideMenu = true;
      if (action.payload == BotTypeEnum.AI_READY_TO_USE) {
        if (state.apiKey) {
          state.create.openAiAPIKey = state.apiKey;
          state.create.chatbotModel = "gpt-3.5-turbo";
          let step: ICreateKnowledgeStep[] = [];

          if (state.create.isEdit) {
            step = state.create.assistantBotSteps.filter(
              (dr) => dr.name != "assistant-choose-model"
            );
          } else {
            step = state.create.assistantBotSteps.filter(
              (dr) => dr.name != "assistant-choose-model"
            );
          }

          state.create.step = step;
        } else {
          state.create.step = state.create.assistantBotSteps;
        }
      } else if (action.payload == BotTypeEnum.AI_WITH_KNOWLEDGE_BASE) {
        if (state.apiKey) {
          state.create.openAiAPIKey = state.apiKey;
          state.create.chatbotModel = "gpt-3.5-turbo";
          let step: ICreateKnowledgeStep[] = [];

          if (state.create.isEdit) {
            step = state.create.kbAssistantBotSteps.filter(
              (dr) => dr.name != "kb-assistant-choose-model"
            );
          } else {
            step = state.create.kbAssistantBotSteps.filter(
              (dr) => dr.name != "kb-assistant-choose-model"
            );
          }

          state.create.step = step;
        } else {
          state.create.step = state.create.kbAssistantBotSteps;
        }
      } else if (action.payload == BotTypeEnum.SITE_SCAN_PLUG_AND_PLAY) {
        if (state.apiKey) {
          state.create.openAiAPIKey = state.apiKey;
          state.create.chatbotModel = "gpt-3.5-turbo";
          let step: ICreateKnowledgeStep[] = [];

          if (state.create.isEdit) {
            step = state.create.ppAssistantBotSteps.filter(
              (dr) => dr.name != "pp-assistant-choose-model"
            );
          } else {
            step = state.create.ppAssistantBotSteps.filter(
              (dr) => dr.name != "pp-assistant-choose-model"
            );
          }

          state.create.step = step;
        } else {
          state.create.step = state.create.ppAssistantBotSteps;
        }
      } else if (action.payload == BotTypeEnum.TEXT_SCENARIO) {
        if (state.create.isEdit) {
          state.create.step = state.create.scenarioSteps.filter(
            (dr) => dr.name != "mainStarterKit"
          );
        } else {
          state.create.step = state.create.scenarioSteps;
        }
      } else if (action.payload == BotTypeEnum.VIDEO_SCENARIO) {
        state.create.step = state.create.VideoScenarioSteps;
      } else if (action.payload == BotTypeEnum.HUMAN_CLONE) {
        if (state.apiKey) {
          state.create.openAiAPIKey = state.apiKey;
          state.create.chatbotModel = "gpt-3.5-turbo";
          let step: ICreateKnowledgeStep[] = [];

          if (state.create.isEdit) {
            step = state.create.assistantCloneBotSteps.filter(
              (dr) => dr.name != "assistant-choose-model"
            );
          } else {
            step = state.create.assistantCloneBotSteps.filter(
              (dr) => dr.name != "assistant-choose-model"
            );
          }

          state.create.step = step;
        } else {
          state.create.step = state.create.assistantCloneBotSteps;
        }
      }

      if (
        state.currentPackageName == null ||
        state.currentPackageName.includes("FREE")
      ) {
        state.create.step = state.create.step.filter(
          (dr) => dr.name != "assistant-choose-model"
        );
      }
    },
    setChatBotModel: (state, action: PayloadAction<string>) => {
      state.create.chatbotModel = action.payload;
    },
    setOpenAIAPIKey: (state, action: PayloadAction<string>) => {
      state.apiKey = action.payload;
      state.create.openAiAPIKey = action.payload;
    },
    setkittyMaxToken: (state, action: PayloadAction<number>) => {
      state.maxToken = action.payload;
    },
    setModel: (state, action: PayloadAction<string>) => {
      state.model = action.payload;
    },
    setXlsValue: (
      state: IKnowledgeState,
      action: PayloadAction<IXlSFile[]>
    ) => {
      state.create.fileXlsValue = action.payload;
    },
    setFile: (state: IKnowledgeState, action: PayloadAction<File>) => {
      state.create.fileXls = action.payload;
    },
    setFileName: (state, action: PayloadAction<string>) => {
      state.create.fileXlsName = action.payload;
    },
    setAssistant: (state, action: PayloadAction<IAssistant>) => {
      state.create.assistant = action.payload;
    },
    setDomainAddress: (state, action: PayloadAction<string>) => {
      state.create.domainAddress = action.payload;
    },
    setInputColumns: (state, action: PayloadAction<string[]>) => {
      state.create.inputs = action.payload;
    },
    setOutputColumns: (state, action: PayloadAction<string[]>) => {
      state.create.outputs = action.payload;
    },
    setNewQuestion: (state, action: PayloadAction<string>) => {
      const questionName: string =
        "Question #" + (state.create.questions.length + 1);
      switch (action.payload) {
        case "multichoice":
          state.create.questions.push({
            isValid: false,
            type: "multichoice",
            name: questionName,
            text: "",
            next: "",
            responses: [
              {
                keywords: [],
                next: "",
                text: ""
              }
            ]
          });
          break;
        case "input":
          state.create.questions.push({
            isValid: false,
            type: "input",
            name: questionName,
            text: "",
            next: "",
            responses: [
              {
                keywords: [],
                next: "",
                text: ""
              }
            ]
          });
          break;
        default:
          break;
      }
    },
    setQuestion: (state, action: PayloadAction<ICreateKnowledgeQuestion>) => {
      const question = state.create.questions.find(
        (dr) => dr.name == action.payload.name
      );
      if (question) {
        question.type = action.payload.type;
        question.isValid = action.payload.isValid;
        question.text = action.payload.text;
        for (let i = 0; i < action.payload.responses.length; i++) {
          question.responses[i].next = action.payload.responses[i].next;
          question.responses[i].text = action.payload.responses[i].text;
          question.responses[i].keywords = action.payload.responses[i].keywords;
        }
        question.next = action.payload.next;
      }
    },
    removeQuestion: (state, action: PayloadAction<string>) => {
      state.create.questions = state.create.questions.filter(
        (dr) => dr.name != action.payload
      );
    },
    setNewGroupOfKeywords: (
      state,
      action: PayloadAction<ICreateKnowledgeQuestion>
    ) => {
      state.create.questions
        .find((dr) => dr.name == action.payload.name)
        ?.responses?.push({
          keywords: [],
          next: "",
          text: ""
        });
    },
    setAssistantInformation: (
      state,
      action: PayloadAction<{
        assistantWelcomeMessage?: string;
        assistantCompanyName: string;
        assistantAgentName: string;
        additional_instruction: string;
      }>
    ) => {
      state.create.assistantWelcomeMessage =
        action.payload.assistantWelcomeMessage;
      state.create.assistantAgentName = action.payload.assistantAgentName;
      state.create.assistantCompanyName = action.payload.assistantCompanyName;
      state.create.additional_instruction =
        action.payload.additional_instruction;
    },
    setBotVersions: (state, action: PayloadAction<IBotVersions[]>) => {
      state.botVersions = action.payload;
    },
    setIsSideMenuCreateKnowledgeBase: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.create.isSideMenu = action.payload;
    },
    nextStep: (state: IKnowledgeState) => {
      let indexStep = state.create.step.findIndex(
        (x) => x.name == state.create.currentStep
      );

      if (indexStep >= 0 && state.create.step.length - 1 > indexStep) {
        indexStep = indexStep + 1;
        state.create.currentStep = state.create.step[indexStep].name;

        state.create.stepNumber = indexStep + 1;
      }

      if (indexStep < state.create.step.length - 1) {
        state.create.isNextStep = true;
      } else {
        state.create.isNextStep = false;
      }

      state.create.isPreviousStep = true;
    },
    previousStep: (state: IKnowledgeState) => {
      let indexStep = state.create.step.findIndex(
        (x) => x.name == state.create.currentStep
      );

      if (indexStep > 0) {
        indexStep = indexStep - 1;
        state.create.currentStep = state.create.step[indexStep].name;

        state.create.stepNumber = indexStep + 1;
      }

      if (indexStep == 0) {
        state.create.isPreviousStep = false;
      } else {
        state.create.isPreviousStep = true;
      }

      state.create.isNextStep = true;
    },
    resetStep: (state: IKnowledgeState) => {
      state.create.stepNumber = 1;
      state.create.currentStep = "main";
      state.create.isNextStep = true;
      state.create.isPreviousStep = false;
    },
    resetCreate: (state: IKnowledgeState) => {
      const botType = state.create.botType;
      state.create = {
        ...initialState.create,
        botType: botType
      };

      localStorage.removeItem("persist:knowledge");
    },
    changeBotType: (
      state: IKnowledgeState,
      action: PayloadAction<"Widget" | "Link">
    ) => {
      state.create.botType = action.payload;
    },
    setPackage: (
      state: IKnowledgeState,
      action: PayloadAction<{
        maxUsageKitty: string | null;
        usageKitty: number | null;
        expiredDate: Date | null;
        defaultScenario: string | null;
      }>
    ) => {
      state.defaultScenario = action.payload.defaultScenario;
      state.expiredDate = action.payload.expiredDate;
      state.maxUsageKitty = action.payload.maxUsageKitty;
      state.usageKitty = action.payload.usageKitty;
    },

    setEditAssistant: (
      state: IKnowledgeState,
      action: PayloadAction<IUpdateKnowledgeAssistant>
    ) => {
      state.create.chatbotService =
        state.create.botType == "Link"
          ? BotTypeEnum.HUMAN_CLONE
          : (action.payload.botService as ICreateKnowledge["chatbotService"]);
      state.create.openAiAPIKey = action.payload.apiKey;
      state.create.id = action.payload.id;
      state.create.isEdit = true;
      state.create.assistantAgentName = action.payload.assistantAgentName;
      state.create.assistantWelcomeMessage =
        action.payload.assistantWelcomeMessage;
      state.create.assistantCompanyName = action.payload.assistantCompanyName;
      state.create.additional_instruction =
        action.payload.additional_instruction;
      state.create.chatbotTitle = action.payload.chatbotTitle;
      state.create.chatbotPrevTitle = action.payload.chatbotTitle;
      state.create.assistantInstructions = action.payload.instructions;
      state.create.domainAddress = action.payload.domainAddress ?? "";
      state.create.ppAutoUpdate = action.payload.ppAutoUpdate ?? "never";
      state.create.chatbotModel = "gpt-3.5-turbo";
      state.create.SpeedModel = action.payload.SpeedModel;
      state.create.assistant = {
        ...state.create.assistant,
        code: action.payload.assistantCode
      } as IAssistant;
      state.create.files = action.payload.files || [];

      if (state.create.botType == "Link") {
        if (state.apiKey) {
          let step: ICreateKnowledgeStep[] = [];
          step = state.create.assistantCloneBotSteps.filter(
            (dr) => dr.name != "assistant-choose-model"
          );
          state.create.step = JSON.parse(JSON.stringify(step));
        } else {
          state.create.step = state.create.assistantCloneBotSteps;
        }
      } else {
        if (state.apiKey) {
          let step: ICreateKnowledgeStep[] = [];
          if (action.payload.botService === BotTypeEnum.AI_READY_TO_USE) {
            step = state.create.assistantBotSteps.filter(
              (dr) => dr.name != "assistant-choose-model"
            );
          } else if (
            action.payload.botService === BotTypeEnum.AI_WITH_KNOWLEDGE_BASE
          ) {
            step = state.create.assistantBotSteps.filter(
              (dr) => dr.name != "kb-assistant-choose-model"
            );
          }
          state.create.step = JSON.parse(JSON.stringify(step));
        } else {
          if (action.payload.botService === BotTypeEnum.AI_READY_TO_USE) {
            state.create.step = state.create.assistantBotSteps;
          } else if (
            action.payload.botService === BotTypeEnum.AI_WITH_KNOWLEDGE_BASE
          ) {
            state.create.step = state.create.kbAssistantBotSteps;
          } else if (
            action.payload.botService === BotTypeEnum.SITE_SCAN_PLUG_AND_PLAY
          ) {
            state.create.step = state.create.ppAssistantBotSteps;
          }
        }
      }
    },
    setEditScenario: (
      state: IKnowledgeState,
      action: PayloadAction<IUpdateKnowledgeAssistant>
    ) => {
      state.create.chatbotService =
        action.payload.botService || BotTypeEnum.TEXT_SCENARIO;
      state.create.id = action.payload.id;
      state.create.isEdit = true;
      state.create.chatbotTitle = action.payload.chatbotTitle;
      state.create.chatbotPrevTitle = action.payload.chatbotTitle;
      state.create.step =
        action.payload.botService == BotTypeEnum.VIDEO_SCENARIO
          ? state.create.VideoScenarioSteps
          : state.create.scenarioSteps;
    },
    resetPackage: (state: IKnowledgeState) => {
      state.apiKey = null;
      state.defaultScenario = null;
      state.expiredDate = null;
      state.maxUsageKitty = null;
      state.usageKitty = null;
    },
    setSelectServiceFromOutside: (state: IKnowledgeState) => {
      state.create.selectServiceFromOutside = true;
    },
    setPPAutoUpdate(
      state: IKnowledgeState,
      action: PayloadAction<IUpdateKnowledgeAssistant["ppAutoUpdate"]>
    ) {
      state.create.ppAutoUpdate = action.payload || "never";
    },
    setScenarioTemplateId(
      state: IKnowledgeState,
      action: PayloadAction<number>
    ) {
      state.create.scenarioTemplateId = action.payload;
    },
    setSpeedModel(
      state,
      action: PayloadAction<"SMART" | "SMART_FAST" | "FAST_SMART" | "FAST">
    ) {
      state.create.SpeedModel = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ChatbotRTKService.endpoints.createModel.matchFulfilled,
      (state, action) => {
        state.apiKey = state.create.openAiAPIKey;
      }
    );
    builder.addMatcher(
      ChatbotRTKService.endpoints.getPackage.matchFulfilled,
      (state, action) => {
        if (action?.payload?.plan) {
          state.currentPackageName = action?.payload?.plan;
        }
        if (action?.payload?.config) {
          state.apiKey = action?.payload?.config.aikitty_defaults?.apiKey;
          state.maxToken =
            action?.payload?.config.aikitty_defaults?.maxToken ?? 1000;
          state.model = action?.payload?.config.aikitty_defaults?.model;
        }
      }
    );
  }
});

export const {
  nextStep,
  previousStep,
  resetStep,
  setXlsValue,
  setChatbotTitle,
  setChatBotService,
  setAssistantInformation,
  resetCreate,
  setChatBotModel,
  setOpenAIAPIKey,
  setkittyMaxToken,
  setFileName,
  setFile,
  setInputColumns,
  setOutputColumns,
  setNewQuestion,
  setNewGroupOfKeywords,
  setQuestionText,
  setQuestionLink,
  removeQuestion,
  setQuestionSectionLink,
  setQuestionSectionKeywords,
  setQuestionSectionText,
  setQuestion,
  setPackage,
  setBotVersions,
  resetPackage,
  changeBotType,
  setIsSideMenuCreateKnowledgeBase,
  setEditAssistant,
  setEditScenario,
  setAssistant,
  setDomainAddress,
  setSelectServiceFromOutside,
  setPPAutoUpdate,
  setScenarioTemplateId,
  setSpeedModel
} = KnowledgeSlice.actions;

export const selectKnowledgeCreate = (state: RootState) =>
  (state?.knowledgestate as IKnowledgeState).create;

export const selectKnowledge = (state: RootState) =>
  state?.knowledgestate as IKnowledgeState;

export default KnowledgeSlice.reducer;
